import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

function NoAdminAccess() {
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      backgroundColor: 'var(--admin-bg, #1a1410)',
      color: 'var(--admin-text-primary, #f5e6d3)',
      textAlign: 'center'
    }}>
      <div style={{
        maxWidth: '480px',
        padding: '2.5rem',
        backgroundColor: 'var(--admin-surface, #2a1f17)',
        border: '1px solid var(--admin-border, #4a3826)',
        borderRadius: '1rem'
      }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem' }}>
          Admin access required
        </h1>
        <p style={{ fontSize: '1rem', lineHeight: 1.6, marginBottom: '1.5rem', opacity: 0.85 }}>
          You don't have admin access to this page. If you believe this is an error contact{' '}
          <a href="mailto:support@dipps.ca" style={{ color: 'var(--admin-accent, #d4a574)' }}>
            support@dipps.ca
          </a>
          . Return to your dashboard.
        </p>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: 'var(--admin-accent, #d4a574)',
            color: 'var(--admin-bg, #1a1410)',
            border: 'none',
            borderRadius: '0.5rem',
            fontWeight: 600,
            fontSize: '0.95rem',
            cursor: 'pointer'
          }}
        >
          Return to dashboard
        </button>
      </div>
    </div>
  );
}

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(false);
  const [denied, setDenied] = useState(false);
  useEffect(() => {
    async function check() {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) { navigate('/sign-in'); return; }
      const { data: profile } = await supabase.from('profiles').select('role').eq('id', user.id).single();
      const adminRoles = ['hca_independent', 'facility', 'admin', 'superadmin'];
      if (!profile || !adminRoles.includes(profile.role)) {
        setDenied(true);
        return;
      }
      setAllowed(true);
    }
    check();
  }, []);
  if (denied) return <NoAdminAccess />;
  if (!allowed) return null;
  return <>{children}</>;
}

export function SeniorGuard({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(false);
  useEffect(() => {
    async function check() {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) { navigate('/sign-in'); return; }
      const { data: profile } = await supabase.from('profiles').select('role').eq('id', user.id).single();
      const seniorRoles = ['senior', 'family', 'hca_independent', 'facility', 'admin', 'superadmin'];
      if (!profile || !seniorRoles.includes(profile.role)) {
        navigate('/admin');
        return;
      }
      setAllowed(true);
    }
    check();
  }, []);
  if (!allowed) return null;
  return <>{children}</>;
}
